@if (!this.noPagination) {
    <div class="mxs-paginator">

        <div class="mxs-paginator_label">
            {{ 'Items per page: ' | translate }}
        </div>

        <mat-select
                class="mxs-paginator_dropdown"
                [(ngModel)]="pageSize"
                hideSingleSelectionIndicator="true"
                [disableOptionCentering]="true"
                (selectionChange)="onPageSizeChanged($event)"
        >
            <mat-option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</mat-option>
        </mat-select>

        <mat-paginator #paginator
                       hidePageSize="true"
                       [pageSize]="pageSize"
                       [pageIndex]="pageIndex"
                       [showFirstLastButtons]="true"
                       (page)="onPageChanged($event)"
        >
        </mat-paginator>

    </div>
}
